import { Paginated } from "../../../shared/types/IPaginationResponse";
import apiClient from "../../../shared/config/axios";
import { User, UserFilters, CreateUserDto, UpdateUserDto } from "@myapp/contract";

export const userApi = {
  search: (params: UserFilters & { page: number }) =>
    apiClient.get<Paginated<User>>('/users', { params }),

  getById: (id: string) =>
    apiClient.get<User>(`/users/${id}`),

  create: (data: CreateUserDto) =>
    apiClient.post<User>('/users', data),

  update: (id: string, data: UpdateUserDto) =>
    apiClient.patch<User>(`/users/${id}`, data),

  archive: (id: string) =>
    apiClient.post<void>(`/users/${id}/archive`),

  restore: (id: string) =>
    apiClient.post<void>(`/users/${id}/restore`),
}